<template>
    <myPage :max_flag="true">
        <div class="flex-box nopadding wrap pd-left5 pd-bottom5" slot="header">
            <el-button-group class="mg-right5 mg-top5 flex-box nopadding">
                <el-button size="small" :title="$t('refs')" icon="el-icon-refresh" @click="list()"></el-button>
                <el-button size="small" @click="exportExcel" :title="$t('export')" icon="el-icon-download"></el-button>
            </el-button-group>
            <div class="f-bd f14 text-nowrap">移动时间{{$t('x_mh')}}</div>
            <div class="mg-right5 mg-top5"><myDatePicker v-model="search.datearea_id" @onChange="onDateChange"></myDatePicker></div>
            <div class="mg-top5"><el-button size="small" @click="list()">{{$t('list')}}</el-button></div>
        </div>
        <div class="fillw fillh">
            <el-table :data="listData" style="width: 100%" height="100%">
                <el-table-column :label="listHeader.add_time">
                    <el-table-column label-class-name="f-red pd-top0" width="160px">
                        <template slot-scope="scope" slot="header">合计</template>
                        <div class="f-bd" slot-scope="scope">{{scope.row.add_time}}</div>
                    </el-table-column>
                </el-table-column>
                <el-table-column width="150px" prop="cr_cat_cdesc">
                    <template slot-scope="scope" slot="header">
                        <myDropdown :title="listHeader.cr_cat_cdesc" :list="cr_cat" v-model="search.cr_cat"
                                    title_class="f12 f-blue" key_name="value" value_name="key" @onChange="list()"></myDropdown>
                    </template>
                </el-table-column>
                <el-table-column width="120px" prop="sn_type_cdesc">
                    <template slot-scope="scope" slot="header">
                        <myDropdown :title="listHeader.sn_type_cdesc" :list="sn_type" v-model="search.sn_type"
                                    title_class="f12 f-blue" key_name="value" value_name="key" @onChange="list()"></myDropdown>
                    </template>
                </el-table-column>
                <el-table-column :label="listHeader.mv_cr_qty">
                    <el-table-column label-class-name="f-red pd-top0" width="120px">
                        <template slot-scope="scope" slot="header">{{totalData.sum.mv_cr_qty * 1}}</template>
                        <div class="f-red f-bd" slot-scope="scope"><span v-if="scope.row.mv_cr_qty * 1 > 0">+</span>{{scope.row.mv_cr_qty * 1}}</div>
                    </el-table-column>
                </el-table-column>
                <el-table-column :label="listHeader.new_cr_qty" width="120px">
                    <template slot-scope="scope">{{scope.row.new_cr_qty * 1}}</template>
                </el-table-column>
                <el-table-column prop="vendor_cname" :label="listHeader.vendor_cname" min-width="150px"> </el-table-column>
                <el-table-column prop="order_code" :label="listHeader.order_code" min-width="160px"> </el-table-column>
            </el-table>
        </div>
        <div slot="footer">
            <myPager slot="footer" :limit="search.limit" @onLimitChange="onLimitChange"
                     v-model="search.page" :pageSize="search.pageSize" @onPagerChange="onPagerChange"></myPager>
        </div>
    </myPage>
</template>

<script>
    import myDatePicker from "./myDatePicker";
    import myPager from "./myPager";
    import myDropdown from "./myDropdown";
    export default {
        name: "myVendorCrSn",
        components:{
            myDatePicker,
            myPager,
            myDropdown
        },
        props: {
            vendor_id: {
                default: '',
                type: String,
            }
        },
        data:function(){
            const listHeader = {
                add_time: '移动时间',
                vendor_cname: '供应商',
                cr_cat_cdesc: '信誉消费模式',
                sn_type_cdesc: '类型',
                order_code: '订单号',
                mv_cr_qty: '移动数量',
                new_cr_qty: '结存'
            };
            return{
                self:this,
                search:{
                    search_url: "vendor-cr-sn/list",
                    datearea_id:1,//如果大于0 mounted 要删除date_fr date_to
                    date_fr: '',
                    date_to: '',
                    page: 1,
                    limit: 30,
                    pageSize: 0,
                    dev_cname: '',
                    cr_cat: '',
                    sn_type: ''
                },
                listHeader,//表结构
                listData: [],
                totalData: {
                    total: 0,//总行数
                    sum:{}
                },
                cr_cat:[
                    {
                        key:'',
                        value:this.$t('all')
                    }
                ],
                sn_type:[
                    {
                        key:'',
                        value:this.$t('all')
                    }
                ]
            }
        },
        mounted: function(){
            this.$base.setMenuOpens();
            this.$base.listPageInit(this,()=>{
                this.getLoad();
            });
        },
        methods:{
            onDateChange: function(data){
                this.search.date_fr = data[0];
                this.search.date_to = data[1];
            },
            onPagerChange: function () {
                this.list(true);
            },
            onLimitChange: function (limit) {
                this.search.limit = limit;
                this.list();
            },
            getLoad: function () {
                this.$base.showLoading();
                this.$request.sendPost("vendor-cr-sn/before-list",{},(success,data,error)=>{
                    this.$base.hideLoading();
                    if(success){
                        this.cr_cat = this.cr_cat.concat(data.cr_cat);
                        this.sn_type = this.sn_type.concat(data.sn_type);
                        this.list()
                    }
                    else{
                        this.$base.alertErr(error.errmsg);
                    }
                });
            },
            list: function (change_page) {
                this.search.vendor_id = this.vendor_id;
                this.$base.list(this, change_page);
            },
            exportExcel: function(){
                this.$base.exportExcel(this);
            }
        }
    }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/myVendorCrSn.vue